import type { InboxNotification } from '~/features/notifications/types/notifications.api.types';

/**
 * Resolves the destination route for a notification click based on its type code
 * and entity reference. Returns a TanStack Router path string.
 *
 * When the backend ships and notification types are finalised, extend the switch
 * statement — the entity_ref.id field is intentionally available for deep-linking.
 */
export function getNotificationRoute(notification: InboxNotification): string {
  const { type } = notification;

  if (type.startsWith('feed.')) {
    return '/integrations/activity';
  }

  if (type.startsWith('experiment.')) {
    return '/experiments';
  }

  if (type.startsWith('calibration.')) {
    return '/catalog-operations';
  }

  if (type.startsWith('catalog.')) {
    return '/catalog-manager';
  }

  // Unknown type — stay on the inbox page rather than confusing the user
  // with a settings page navigation.
  return '/notification';
}
